import {BaseModel} from './base.model';
import {IUserDomain} from './database';
import {Domain} from './domain.model';


export class UserDomain extends BaseModel<IUserDomain> implements IUserDomain {
  domain_id: number;
  id: number;
  join_date: Date;
  leave_date: Date | null;
  user_id: number;
}

export class UserDomainDetails extends Domain {
  join_date: Date;
  user_id: number;
}
